import { Box, Button, Text, Truncate } from "@twilio-paste/core";
import { ProductAssetsIcon } from "@twilio-paste/icons/cjs/ProductAssetsIcon";
import { CloseIcon } from "@twilio-paste/icons/cjs/CloseIcon";
import { ReduxMedia } from "../../store/reducers/messageListReducer";

type MessageFileProps = {
  media: ReduxMedia | { filename: string; size: number };
  onRemove?: () => void;
  isMobile?: boolean;
};

const MessageFile: React.FC<MessageFileProps> = ({
  media,
  onRemove,
  isMobile = false,
}: MessageFileProps) => {
  const { filename, size } = media;
  const name = filename ?? "";
  const sizeInMb = Math.round((size / Math.pow(2, 20)) * 100) / 100;

  if (isMobile) {
    return (
      <Box
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "8px 10px",
          margin: "8px 8px 0 0",
          border: "1px solid rgba(57, 71, 98, 0.12)",
          boxSizing: "border-box",
          borderRadius: "999px",
          maxWidth: "100%",
          backgroundColor: "#F7F9FF",
          cursor: "default",
        }}
      >
        <Box
          style={{
            width: 26,
            height: 26,
            minWidth: 26,
            borderRadius: "999px",
            backgroundColor: "#E8EEFF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ProductAssetsIcon
            decorative={false}
            title="Attached file"
            size="sizeIcon20"
            color="colorTextLink"
          />
        </Box>
        <Box
          style={{
            minWidth: 0,
            maxWidth: 180,
          }}
        >
          <Text
            as="p"
            fontWeight="fontWeightMedium"
            fontSize="fontSize20"
            lineHeight="lineHeight20"
          >
            <Truncate title={name}>{name}</Truncate>
          </Text>
          <Text as="p" color="colorTextWeak" fontSize="fontSize10">
            {sizeInMb} MB
          </Text>
        </Box>
        {onRemove ? (
          <button
            type="button"
            onClick={onRemove}
            aria-label={`Remove ${name}`}
            style={{
              width: 24,
              height: 24,
              minWidth: 24,
              borderRadius: "999px",
              border: "none",
              backgroundColor: "#06033A",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              padding: 0,
            }}
          >
            <CloseIcon
              decorative={false}
              title="Remove file"
              color="colorTextBrandInverse"
            />
          </button>
        ) : null}
      </Box>
    );
  }

  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        padding: "12px 16px",
        margin: "6px 6px 0 6px",
        border: "1px solid #CACDD8",
        boxSizing: "border-box",
        borderRadius: "4px",
        width: "calc(25% - 20px)",
        maxWidth: "200px",
        minWidth: "150px",
        backgroundColor: "#fff",
        cursor: "default",
      }}
    >
      <Box
        style={{
          marginRight: "16px",
          alignItems: "start",
          fontWeight: "bold",
        }}
      >
        <ProductAssetsIcon
          decorative={false}
          title="Open File"
          size="sizeIcon60"
          color="colorTextLink"
        />
      </Box>

      <Box
        style={{
          maxWidth: "calc(100% - 42px)",
        }}
      >
        <Text as="p" fontWeight="fontWeightMedium">
          <Truncate title={name}>{name}</Truncate>
        </Text>
        <Text as="p" color="colorTextInverseWeaker">
          {sizeInMb} MB
        </Text>
      </Box>

      {onRemove ? (
        <Button variant="link" onClick={onRemove}>
          <Box
            style={{
              backgroundColor: "#06033A",
              borderRadius: "10px",
              top: "-45px",
              position: "absolute",
              left: "2%",
            }}
          >
            <CloseIcon
              decorative={false}
              title="Remove file"
              color="colorTextBrandInverse"
            />
          </Box>
        </Button>
      ) : null}
    </Box>
  );
};

export default MessageFile;
